import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "col-span-2" };
const _hoisted_2 = { class: "col-span-2 md:col-span-1" };
const _hoisted_3 = { class: "col-span-2" };
const _hoisted_4 = { class: "col-span-2 md:col-span-1" };
const _hoisted_5 = { class: "col-span-2 md:col-span-1" };
const _hoisted_6 = { class: "col-span-2 md:col-span-1" };
const _hoisted_7 = { class: "col-span-2 md:col-span-1" };
const _hoisted_8 = { class: "col-span-2" };
const _hoisted_9 = { class: "col-span-2 md:col-span-1" };
const _hoisted_10 = { class: "col-span-2 md:col-span-1" };
const _hoisted_11 = { class: "col-span-2 md:col-span-1" };
const _hoisted_12 = { class: "col-span-2 md:col-span-1" };
const _hoisted_13 = { class: "col-span-2 md:col-span-1" };
const _hoisted_14 = ["aria-label"];
const _hoisted_15 = { class: "col-span-2 md:col-span-1" };
const _hoisted_16 = { class: "col-span-2 md:col-span-1" };
const _hoisted_17 = ["aria-label"];
const _hoisted_18 = { class: "col-span-2 md:col-span-1" };
const _hoisted_19 = { class: "col-span-2 md:col-span-1" };
const _hoisted_20 = { class: "col-span-2 md:col-span-1" };
const _hoisted_21 = { class: "col-span-2" };
const _hoisted_22 = { class: "col-span-2" };
const _hoisted_23 = { class: "col-span-2" };
import { computed, onMounted, ref, toRef, watch } from "vue";
import { useI18n } from "vue-i18n";
import { buildRemoveChipLabel } from "@/shared/composables/removeChipLabel";
import { AutoComplete, Button, ConfirmDeleteModal, DatePickerInput, Dropdown, MultipleSelect, Popover, SelectInput, Textarea, TextInput, Tooltip, UrlInput, useFormValidation, } from "@eudonet/opal";
import { usePermissions } from "@/shared/composables";
import { useAddressFormHydrated } from "../../../composables/useAddressForm";
import { useActivityCodeCatalog } from "../../../composables/useActivityCodeCatalog";
import { useLegalFormCatalog } from "../../../composables/useLegalFormCatalog";
import { searchOrganisations } from "../../../infrastructure/adapters/organisationService";
import { logger } from "@/infrastructure/services/LoggerService";
import { buildAutoCompleteLabels } from "@/shared/composables/autoCompleteLabels";
import { KNOWN_INDUSTRY_SECTORS, INDUSTRY_SECTOR_FALLBACK, } from "../../../domain/industry-sector";
import { RELATION_TYPE_THEME_MAP } from "../../../domain/relation-type";
import { findMainAddress } from "../../../domain/address-utils";
import { useWorkspaceCountry } from "@/shared/composables/useWorkspaceCountry";
import { requiredAddressFields, toAddressLayout } from "@/shared/utils/addressFieldConfig";
import { useAddressesWidget } from "../../../composables/useAddressesWidget";
import { useOrganisationStore } from "../../../stores/useOrganisationStore";
import { useAppToast } from "@/shared/composables/useAppToast";
import { resolveApiErrorMessage } from "@/infrastructure/services/ApiErrorService";
import LayoutRenderer from "@/shared/components/LayoutRenderer.vue";
import AddressesWidget from "../AddressesWidget.vue";
import AddressesExpandModal from "../AddressesExpandModal.vue";
import AddressFormModal from "../AddressFormModal.vue";
import AddressDetailsModal from "../AddressDetailsModal.vue";
import CreateOrganisationModal from "../CreateOrganisationModal.vue";
import { SocialProfileFormModal } from "@/shared/components/social-profiles";
import OrganisationAddPhoneModal from "../OrganisationAddPhoneModal.vue";
import OrganisationEditPhoneModal from "../OrganisationEditPhoneModal.vue";
import OrganisationAddEmailModal from "../OrganisationAddEmailModal.vue";
import OrganisationEditEmailModal from "../OrganisationEditEmailModal.vue";
import OrganisationCoordonneesSection from "../OrganisationCoordonneesSection.vue";
import OrganisationSocialProfileSection from "../OrganisationSocialProfileSection.vue";
import { deleteOrganisationCommunicationChannel, organisationSocialProfileApi, } from "../../../infrastructure/api/organisationApi";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrganisationTabDetails',
    props: {
        organisationId: {},
        state: {},
        entityLayout: {},
        layoutHeaders: {},
        addresses: {},
        formIsDirty: { type: Boolean, default: false }
    },
    emits: ["channelSaved"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t } = useI18n();
        const removeChipLabel = buildRemoveChipLabel(t);
        const { canEditOphub: canEdit, disabledTooltip } = usePermissions();
        const canInteractWithChannels = computed(() => canEdit.value && !props.formIsDirty);
        const channelTooltip = computed(() => props.formIsDirty
            ? t("organisation.detail.communication.saveBeforeEditing")
            : disabledTooltip.value);
        const organisationStore = useOrganisationStore();
        const { toastSuccess, toastError } = useAppToast();
        const org = props.state;
        const { addressDetails, isAddressDirty, currentAddressQuery, addressSuggestions, addressLoading, showAddressDetailsModal: showAddressModal, onAddressSearch, onAddressSelect, openAddressDetailsModal: openAddressModal, syncAddressDetailsFromQuery, onBeforeAddressSave, pointToSave, } = useAddressFormHydrated(() => findMainAddress(organisationStore.addresses));
        // Stable temp ID for a new address when no main address exists yet.
        const tempAddressId = ref(null);
        watch(isAddressDirty, (dirty, wasDirty) => {
            if (dirty && !wasDirty) {
                if (!findMainAddress(organisationStore.addresses)) {
                    tempAddressId.value = crypto.randomUUID();
                }
            }
            if (!dirty)
                tempAddressId.value = null;
        });
        const addressLayout = useWorkspaceCountry();
        function buildPrimaryAddressFromForm() {
            const mainAddress = findMainAddress(organisationStore.addresses);
            const saved = toAddressLayout(addressDetails, addressLayout.value);
            const point = pointToSave();
            return {
                id: mainAddress?.id ?? tempAddressId.value ?? "",
                type: (mainAddress?.type ?? "Headquarters"),
                line1: saved.line1 || undefined,
                line2: saved.line2 || undefined,
                line3: saved.line3 || undefined,
                houseNumber: saved.houseNumber || undefined,
                houseNumberSuffix: saved.houseNumberSuffix || undefined,
                postalCode: saved.postalCode || undefined,
                city: saved.city || undefined,
                region: saved.region || undefined,
                country: saved.country || undefined,
                latitude: point?.latitude,
                longitude: point?.longitude,
                isPrimary: mainAddress?.isPrimary ?? !mainAddress,
            };
        }
        // CONSTRAINT: dirty-only on purpose — a legacy stored address missing a required
        // field must not block saving the other fields of the fiche.
        const missingAddressField = computed(() => {
            const pending = pendingPrimaryAddress.value;
            if (!pending)
                return undefined;
            return requiredAddressFields(addressLayout.value).find((field) => !pending[field.key]?.trim());
        });
        const showAddressRequiredError = ref(false);
        watch(currentAddressQuery, () => {
            showAddressRequiredError.value = false;
        });
        const addressFieldError = computed(() => {
            const key = missingAddressField.value?.requiredMessageKey;
            return showAddressRequiredError.value && key ? t(key) : undefined;
        });
        // Derives the pending address from the live form state — no imperative store writes needed.
        const pendingPrimaryAddress = computed(() => {
            if (!isAddressDirty.value)
                return null;
            return buildPrimaryAddressFromForm();
        });
        // Overlays the pending form address on the store list so the widget stays in sync.
        // Only replaces an existing main address — never appends a temp-id row that BFF doesn't know.
        const displayedAddresses = computed(() => {
            const pending = pendingPrimaryAddress.value;
            if (!pending)
                return props.addresses;
            const mainAddress = findMainAddress(props.addresses);
            if (!mainAddress)
                return props.addresses;
            return props.addresses.map((a) => (a.id === mainAddress.id ? pending : a));
        });
        const sortedAddresses = computed(() => [...displayedAddresses.value].sort((a, b) => {
            if (a.isPrimary !== b.isPrimary)
                return Number(b.isPrimary) - Number(a.isPrimary);
            if (a.type !== b.type)
                return a.type.localeCompare(b.type);
            const cityA = a.city ?? "";
            const cityB = b.city ?? "";
            if (cityA !== cityB)
                return cityA.localeCompare(cityB);
            return (a.line1 ?? "").localeCompare(b.line1 ?? "");
        }));
        // ─── Validation ───────────────────────────────────────────────────────────────
        const { getFieldError: getInternalFieldError, validateAll, validateAndSetField, } = useFormValidation({
            requiredMessage: () => t("errors.required"),
            watchData: org.mainInformation,
        });
        const serverFieldErrors = ref({});
        function getFieldError(fieldKey) {
            for (const [key, msg] of Object.entries(serverFieldErrors.value)) {
                if (key.endsWith(`:${fieldKey}`))
                    return msg;
            }
            return getInternalFieldError(fieldKey);
        }
        function setServerErrors(errors) {
            serverFieldErrors.value = Object.fromEntries(errors.map((e) => [`${e.blockId}:${e.fieldKey}`, resolveServerErrorMessage(e)]));
        }
        function resolveServerErrorMessage(e) {
            // "required" carries no per-context detail beyond the localized "this field is required"
            // — always prefer the user-locale translation over the upstream English string the BFF
            // emits ("Legal name is required.", …).
            // "invalid" / "saveFailed" map to generic localized phrasings; the upstream message,
            // when present, carries the specific reason (OPHUB FluentValidation rejection, BFF
            // ProblemDetails Detail) and is more useful to the user.
            // Follow-up: once OPHUB validators are routed through OnePlatform.Localization,
            // drop the upstream fallback and rely on the localized translation in every case.
            if (e.errorCode === "required") {
                return t(`errors.${e.errorCode}`);
            }
            if (e.errorCode === "invalid") {
                return e.fieldKey === "domainName" ? t("errors.domain") : t("errors.invalid");
            }
            return e.message?.trim() || t(`errors.${e.errorCode}`);
        }
        watch(() => props.state, () => {
            serverFieldErrors.value = {};
        }, { deep: true });
        const legalNameField = computed(() => {
            const block = props.entityLayout?.layout.blocks.find((b) => b.id === "main-info");
            const required = block?.kind === "hardcoded" ? (block.fieldRules["legalName"]?.required ?? false) : false;
            return {
                type: "text",
                key: "legalName",
                label: t("organisation.detail.mainInformation.legalName"),
                required,
            };
        });
        function onLegalNameBlur() {
            validateAndSetField(legalNameField.value, org.mainInformation.legalName);
        }
        function validate() {
            const formValid = validateAll([legalNameField.value], {
                legalName: org.mainInformation.legalName,
            });
            syncAddressDetailsFromQuery();
            const addressValid = !missingAddressField.value;
            showAddressRequiredError.value = !addressValid;
            return formValid && isDomainNameValid.value && addressValid;
        }
        // ─── Phone channels (OP-6251 live-save) ──────────────────────────────────────
        const showAddPhoneModal = ref(false);
        const showEditPhoneModal = ref(false);
        const editingPhone = ref(null);
        const showDeletePhoneConfirm = ref(false);
        const pendingPhoneDelete = ref(null);
        const isDomainNameValid = ref(true);
        const hasPrimaryPhone = computed(() => org.contactInformation.phones.some((p) => p.isPrimary));
        function openEditPhone(phone) {
            editingPhone.value = phone;
            showEditPhoneModal.value = true;
        }
        function onPhoneDeleteRequested() {
            if (!editingPhone.value?.id)
                return;
            pendingPhoneDelete.value = { id: editingPhone.value.id, isPrimary: editingPhone.value.isPrimary };
            showEditPhoneModal.value = false;
            showDeletePhoneConfirm.value = true;
        }
        async function confirmPhoneDelete() {
            const pending = pendingPhoneDelete.value;
            if (!pending)
                return;
            if (pending.isPrimary) {
                toastError("organisation.detail.communication.deletePhoneErrorPrimary");
                pendingPhoneDelete.value = null;
                showDeletePhoneConfirm.value = false;
                return;
            }
            try {
                await deleteOrganisationCommunicationChannel(props.organisationId, pending.id);
                emit("channelSaved");
                toastSuccess("organisation.detail.communication.deleteSuccess");
            }
            catch {
                toastError("organisation.detail.communication.deleteError");
            }
            finally {
                pendingPhoneDelete.value = null;
                showDeletePhoneConfirm.value = false;
            }
        }
        function cancelPhoneDelete() {
            pendingPhoneDelete.value = null;
            showDeletePhoneConfirm.value = false;
        }
        // ─── Email channels (OP-6251 live-save) ──────────────────────────────────────
        const showAddEmailModal = ref(false);
        const showEditEmailModal = ref(false);
        const editingEmail = ref(null);
        const showDeleteEmailConfirm = ref(false);
        const pendingEmailDelete = ref(null);
        const hasPrimaryEmail = computed(() => org.contactInformation.emails.some((e) => e.isPrimary));
        function openEditEmail(email) {
            editingEmail.value = email;
            showEditEmailModal.value = true;
        }
        function onEmailDeleteRequested() {
            if (!editingEmail.value?.id)
                return;
            pendingEmailDelete.value = { id: editingEmail.value.id, isPrimary: editingEmail.value.isPrimary };
            showEditEmailModal.value = false;
            showDeleteEmailConfirm.value = true;
        }
        async function confirmEmailDelete() {
            const pending = pendingEmailDelete.value;
            if (!pending)
                return;
            if (pending.isPrimary) {
                toastError("organisation.detail.communication.deleteEmailErrorPrimary");
                pendingEmailDelete.value = null;
                showDeleteEmailConfirm.value = false;
                return;
            }
            try {
                await deleteOrganisationCommunicationChannel(props.organisationId, pending.id);
                emit("channelSaved");
                toastSuccess("organisation.detail.communication.deleteSuccess");
            }
            catch {
                toastError("organisation.detail.communication.deleteError");
            }
            finally {
                pendingEmailDelete.value = null;
                showDeleteEmailConfirm.value = false;
            }
        }
        function cancelEmailDelete() {
            pendingEmailDelete.value = null;
            showDeleteEmailConfirm.value = false;
        }
        function onDomainNameValidationChange(isValid) {
            isDomainNameValid.value = isValid;
        }
        const hasClientValidationErrors = computed(() => {
            return !isDomainNameValid.value;
        });
        const selectedRelationTypes = toRef(props.state, "selectedRelationTypes");
        async function handleSaveAddressModal() {
            // AddressDetailsModal already gates its Save button (and its `save` emit) on the
            // address-country layout's required fields — nothing left to validate here.
            const address = buildPrimaryAddressFromForm();
            const isNew = !organisationStore.addresses.some((a) => a.id === address.id);
            onBeforeAddressSave();
            try {
                if (isNew) {
                    await organisationStore.addAddress(props.organisationId, address);
                }
                else {
                    await organisationStore.editAddress(props.organisationId, address);
                }
                showAddressModal.value = false;
                toastSuccess(isNew ? "organisation.detail.addresses.addSuccess" : "organisation.detail.addresses.editSuccess");
            }
            catch {
                toastError(isNew ? "organisation.detail.addresses.addError" : "organisation.detail.addresses.editError");
            }
        }
        function onAddressDetailsModalSave(details) {
            Object.assign(addressDetails, details);
            void handleSaveAddressModal();
        }
        __expose({ validate, setServerErrors, pendingPrimaryAddress, isAddressDirty, hasClientValidationErrors });
        const { primaryAddressId, showAddressesModal, showAddressFormModal, editingAddress, showDeleteAddressModal, pendingDeleteAddress, setPrimaryAddress, openAddAddress, openEditAddress, saveAddress, deleteAddress, confirmDeleteAddress, cancelDeleteAddress, } = useAddressesWidget(displayedAddresses, {
            onAdd: async (address) => {
                try {
                    await organisationStore.addAddress(props.organisationId, address);
                    toastSuccess("organisation.detail.addresses.addSuccess");
                }
                catch {
                    toastError("organisation.detail.addresses.addError");
                }
            },
            onEdit: async (address) => {
                try {
                    await organisationStore.editAddress(props.organisationId, address);
                    toastSuccess("organisation.detail.addresses.editSuccess");
                }
                catch {
                    toastError("organisation.detail.addresses.editError");
                }
            },
            onDelete: async (addressId) => {
                try {
                    await organisationStore.removeAddress(props.organisationId, addressId);
                    toastSuccess("organisation.detail.addresses.deleteSuccess");
                }
                catch {
                    toastError("organisation.detail.addresses.deleteError");
                }
            },
            onSetPrimary: async (id) => {
                try {
                    await organisationStore.setPrimaryAddress(props.organisationId, id);
                    toastSuccess("organisation.detail.addresses.setPrimarySuccess");
                }
                catch {
                    toastError("organisation.detail.addresses.editError");
                }
            },
        });
        // ─── Coordonnées add menu (mirrors Contact's coordonneesAddItems dropdown) ────
        const coordonneesAddItems = computed(() => [
            {
                label: t("organisation.detail.communication.addPhone"),
                icon: "ri-phone-line",
                onClick: () => { showAddPhoneModal.value = true; },
            },
            {
                label: t("organisation.detail.communication.addEmail"),
                icon: "ri-mail-line",
                onClick: () => { showAddEmailModal.value = true; },
            },
            {
                label: t("organisation.detail.communication.addSocialLink"),
                icon: "ri-share-line",
                onClick: () => { openAddSocialProfile(); },
            },
        ]);
        // ─── Social profiles (OP-6251 live-save, replaces OP-5494 global-save) ────────
        const socialProfiles = ref([]);
        watch(() => props.state.contactInformation.socialLinks, (links) => { socialProfiles.value = [...links]; }, { immediate: true });
        const showSocialProfileModal = ref(false);
        const editingSocialProfile = ref(null);
        const socialModalError = ref(null);
        const socialModalLoading = ref(false);
        const SOCIAL_ERROR_KEYS = {
            "SocialProfile.SocialNetworkId.Duplicate": "socialProfile.common.networkAlreadyAdded",
        };
        function openAddSocialProfile() {
            editingSocialProfile.value = null;
            socialModalError.value = null;
            showSocialProfileModal.value = true;
        }
        function openEditSocialProfile(profile) {
            editingSocialProfile.value = profile;
            socialModalError.value = null;
            showSocialProfileModal.value = true;
        }
        async function onSocialProfileSave(saved) {
            socialModalLoading.value = true;
            socialModalError.value = null;
            try {
                if (saved.id) {
                    await organisationSocialProfileApi.update(props.organisationId, saved.id, {
                        networkId: saved.networkId,
                        value: saved.value,
                        label: saved.label,
                    });
                    const idx = socialProfiles.value.findIndex((p) => p.id === saved.id);
                    if (idx >= 0) {
                        socialProfiles.value[idx] = { ...socialProfiles.value[idx], ...saved };
                    }
                    toastSuccess("socialProfile.common.updateSuccess");
                }
                else {
                    const newId = await organisationSocialProfileApi.create(props.organisationId, {
                        networkId: saved.networkId,
                        value: saved.value,
                        label: saved.label,
                    });
                    socialProfiles.value.unshift({
                        id: newId,
                        networkId: saved.networkId,
                        networkCode: saved.networkCode,
                        networkName: saved.networkName ?? saved.networkCode,
                        urlPrefix: saved.urlPrefix,
                        iconClass: saved.iconClass,
                        value: saved.value,
                        label: saved.label,
                    });
                    toastSuccess("socialProfile.common.createSuccess");
                }
                showSocialProfileModal.value = false;
            }
            catch (e) {
                socialModalError.value = resolveApiErrorMessage(e, SOCIAL_ERROR_KEYS, saved.id ? "socialProfile.common.updateError" : "socialProfile.common.createError");
            }
            finally {
                socialModalLoading.value = false;
            }
        }
        async function onSocialProfileDelete(profile) {
            socialModalLoading.value = true;
            socialModalError.value = null;
            try {
                await organisationSocialProfileApi.delete(props.organisationId, profile.id);
                socialProfiles.value = socialProfiles.value.filter((p) => p.id !== profile.id);
                showSocialProfileModal.value = false;
                toastSuccess("socialProfile.common.deleteSuccess");
            }
            catch (e) {
                socialModalError.value = resolveApiErrorMessage(e, SOCIAL_ERROR_KEYS, "socialProfile.common.deleteError");
            }
            finally {
                socialModalLoading.value = false;
            }
        }
        function validationIconClass(state) {
            const map = {
                valid: "flex items-center justify-center text-green-500 hover:text-green-600",
                warning: "flex items-center justify-center text-amber-500 hover:text-amber-600",
                error: "flex items-center justify-center text-red-500 hover:text-red-600",
            };
            return map[state];
        }
        function validationIconName(state) {
            const map = {
                valid: "ri-checkbox-circle-line",
                warning: "ri-alert-line",
                error: "ri-close-circle-line",
            };
            return map[state];
        }
        function validationTitleSuffix(state) {
            const map = {
                valid: "Valid",
                warning: "Invalid",
                error: "Error",
            };
            return map[state];
        }
        const relationTypeOptions = computed(() => ["Member", "Partner", "Sponsor"].map((value) => ({
            id: value,
            label: t(`organisation.detail.options.relationType.${value}`),
            badgeTheme: RELATION_TYPE_THEME_MAP[value],
        })));
        const organisationTypeOptions = computed(() => [
            { value: "Entreprise", label: t("organisation.detail.options.organisationType.Entreprise") },
            { value: "OSBL", label: t("organisation.detail.options.organisationType.OSBL") },
            { value: "Fondation", label: t("organisation.detail.options.organisationType.Fondation") },
        ]);
        // Industry sectors follow INSEE NAF rev. 2 sections (French nomenclature) — labels are
        // shipped in French only, same pattern as legalFormOptions. Only the generic "Autre"
        // fallback is translated since it is not part of the INSEE catalogue.
        const industrySectorOptions = computed(() => KNOWN_INDUSTRY_SECTORS.map((value) => ({
            value,
            label: value === INDUSTRY_SECTOR_FALLBACK
                ? t("organisation.detail.options.industrySector.other")
                : value,
        })));
        // LegalForm options come from the BFF INSEE catalogue (loaded once, cached module-scope).
        // INSEE nature_juridique is a French nomenclature so labels are shipped in French only.
        const { entries: legalFormCatalog, load: loadLegalForms } = useLegalFormCatalog();
        const { entries: activityCodeCatalog, load: loadActivityCodes } = useActivityCodeCatalog();
        onMounted(() => {
            loadLegalForms();
            loadActivityCodes();
        });
        const legalFormOptions = computed(() => legalFormCatalog.value.map((entry) => ({
            value: entry.value,
            label: entry.label,
        })));
        // activityCode dropdown: NAF codes displayed as "code – label" (en-dash with spaces) so the
        // user sees both the canonical INSEE identifier and the human description.
        const activityCodeOptions = computed(() => activityCodeCatalog.value.map((entry) => ({
            value: entry.value,
            label: `${entry.value} – ${entry.label}`,
        })));
        const establishmentNatureOptions = computed(() => [
            { value: "Headquarters", label: t("organisation.detail.options.establishmentNature.Headquarters") },
            { value: "Subsidiary", label: t("organisation.detail.options.establishmentNature.Subsidiary") },
            { value: "Branch", label: t("organisation.detail.options.establishmentNature.Branch") },
            {
                value: "RepresentativeOffice",
                label: t("organisation.detail.options.establishmentNature.RepresentativeOffice"),
            },
        ]);
        // LegalStatus options — the 3 user-selectable transitions. `Ceased` is SIRENE-driven so
        // it is appended only when the persisted value is `Ceased` (otherwise the SelectInput
        // would render an empty input for that state and let the user overwrite it). When that
        // branch fires, the field is also locked via :disabled at the template level.
        const legalStatusOptions = computed(() => {
            const base = [
                { value: "Active", label: t("organisation.legalStatus.Active") },
                { value: "Dissolved", label: t("organisation.legalStatus.Dissolved") },
                { value: "InLiquidation", label: t("organisation.legalStatus.InLiquidation") },
            ];
            if (org.administrativeInformation.legalStatus === "Ceased") {
                return [...base, { value: "Ceased", label: t("organisation.legalStatus.Ceased") }];
            }
            return base;
        });
        // ─── Parent organisation picker (OP-5509) ──────────────────────────────────────
        // AutoComplete contract: modelValue is the option id; the component renders the matching
        // option's label and falls back to displaying the raw modelValue when no option matches.
        // So we seed `parentOrganisationSuggestions` with the persisted {id, name} on mount and
        // keep the seed in sync when the form rehydrates, so the picker always finds a label.
        const parentOrganisationSuggestions = ref(org.administrativeInformation.parentOrganisationId && org.administrativeInformation.parentOrganisationName
            ? [{
                    value: org.administrativeInformation.parentOrganisationId,
                    label: org.administrativeInformation.parentOrganisationName,
                }]
            : []);
        watch(() => [
            org.administrativeInformation.parentOrganisationId,
            org.administrativeInformation.parentOrganisationName,
        ], ([id, name]) => {
            if (id && name && !parentOrganisationSuggestions.value.some((o) => o.value === id)) {
                parentOrganisationSuggestions.value = [{ value: id, label: name }];
            }
        });
        let parentSearchSeq = 0;
        function onParentOrganisationModelUpdate(value) {
            // AutoComplete emits update:modelValue("") when the user starts typing over a confirmed
            // selection AND when the inline clear button is clicked. Both should null the FK so the
            // form never persists a stale parent — the @select handler is the only path that
            // re-populates id+name when the user picks from the dropdown.
            if (!value) {
                org.administrativeInformation.parentOrganisationId = null;
                org.administrativeInformation.parentOrganisationName = null;
                // Drop the captured search term so a later "create new" (opened without
                // retyping) doesn't pre-fill a stale name (OP-6103).
                parentOrgQuery.value = "";
            }
        }
        async function onParentOrganisationSearch(query) {
            const trimmed = query.trim();
            // Remember the latest term so the nested create modal can pre-fill it (OP-6103).
            parentOrgQuery.value = trimmed;
            if (trimmed.length < 2) {
                parentOrganisationSuggestions.value = [];
                return;
            }
            const seq = ++parentSearchSeq;
            try {
                const response = await searchOrganisations({ search: trimmed, pageSize: 10 });
                if (seq !== parentSearchSeq)
                    return; // stale result; a newer query is in flight
                parentOrganisationSuggestions.value = response.result
                    .filter((o) => o.id !== props.organisationId)
                    .map((o) => {
                    const acronym = o.mainInformation.acronym?.trim();
                    const legalName = o.mainInformation.legalName?.trim() || o.id;
                    return { value: o.id, label: acronym ? `${legalName} (${acronym})` : legalName };
                });
            }
            catch (error) {
                logger.error("Parent organisation search failed", error);
                if (seq === parentSearchSeq)
                    parentOrganisationSuggestions.value = [];
            }
        }
        function onParentOrganisationSelect(option) {
            org.administrativeInformation.parentOrganisationId = option.value;
            org.administrativeInformation.parentOrganisationName = option.label;
            // An existing parent was picked — clear the term so a subsequent "create new"
            // doesn't pre-fill it (OP-6103).
            parentOrgQuery.value = "";
        }
        // ─── Nested: Create new parent organisation (same pattern as relation/foyer modals) ──
        const showCreateParentOrg = ref(false);
        const createParentOrgMounted = ref(false);
        // Latest text typed in the parent-organisation picker, carried over to pre-fill
        // the nested create modal's legal-name field (OP-6103).
        const parentOrgQuery = ref("");
        watch(showCreateParentOrg, (v) => {
            if (v)
                createParentOrgMounted.value = true;
        });
        function openCreateParentOrg() {
            showCreateParentOrg.value = true;
        }
        function onParentOrgCreated(newId, name) {
            showCreateParentOrg.value = false;
            const option = { value: newId, label: name || newId };
            parentOrganisationSuggestions.value = [option];
            onParentOrganisationSelect(option);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (props.entityLayout)
                    ? (_openBlock(), _createBlock(LayoutRenderer, {
                        key: 0,
                        layout: props.entityLayout,
                        headers: props.layoutHeaders,
                        "extra-items": [{ id: 'addresses', order: 5 }],
                        "row-gap-block-ids": ['communication'],
                        masonry: ""
                    }, {
                        "main-info:legalName": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_1, [
                                _createVNode(_unref(TextInput), {
                                    modelValue: _unref(org).mainInformation.legalName,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(org).mainInformation.legalName) = $event)),
                                    label: _ctx.$t('organisation.detail.mainInformation.legalName'),
                                    required: rules.required,
                                    disabled: rules.readonly,
                                    maxlength: 255,
                                    error: getFieldError('legalName'),
                                    "full-width": "",
                                    onBlur: onLegalNameBlur
                                }, null, 8 /* PROPS */, ["modelValue", "label", "required", "disabled", "error"])
                            ])
                        ]),
                        "main-info:acronym": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(_unref(TextInput), {
                                    modelValue: _unref(org).mainInformation.acronym,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(org).mainInformation.acronym) = $event)),
                                    label: _ctx.$t('organisation.detail.mainInformation.acronym'),
                                    required: rules.required,
                                    disabled: rules.readonly,
                                    maxlength: 10,
                                    error: getFieldError('acronym'),
                                    "full-width": ""
                                }, null, 8 /* PROPS */, ["modelValue", "label", "required", "disabled", "error"])
                            ])
                        ]),
                        "main-info:address": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(_unref(AutoComplete), _mergeProps(_unref(buildAutoCompleteLabels)(_unref(t)), {
                                    "model-value": _unref(currentAddressQuery),
                                    label: _ctx.$t('organisation.detail.mainInformation.address'),
                                    placeholder: _ctx.$t('organisation.detail.mainInformation.addressPlaceholder'),
                                    options: _unref(addressSuggestions),
                                    loading: _unref(addressLoading),
                                    disabled: rules.readonly,
                                    clearable: false,
                                    error: addressFieldError.value,
                                    "show-add-more-details": "",
                                    "add-more-details-label": _unref(canEdit)
                                        ? _ctx.$t('organisation.detail.mainInformation.addressAddMoreDetails')
                                        : _ctx.$t('organisation.detail.mainInformation.addressViewDetails'),
                                    "full-width": "",
                                    onSearch: _unref(onAddressSearch),
                                    onSelect: _unref(onAddressSelect),
                                    onAddMoreDetails: _unref(openAddressModal)
                                }), null, 16 /* FULL_PROPS */, ["model-value", "label", "placeholder", "options", "loading", "disabled", "error", "add-more-details-label", "onSearch", "onSelect", "onAddMoreDetails"])
                            ])
                        ]),
                        "main-info:organisationType": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_4, [
                                _createVNode(_unref(SelectInput), {
                                    modelValue: _unref(org).mainInformation.organisationType,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(org).mainInformation.organisationType) = $event)),
                                    label: _ctx.$t('organisation.detail.mainInformation.organisationType'),
                                    options: organisationTypeOptions.value,
                                    required: rules.required,
                                    disabled: rules.readonly,
                                    error: getFieldError('organisationType'),
                                    "full-width": ""
                                }, null, 8 /* PROPS */, ["modelValue", "label", "options", "required", "disabled", "error"])
                            ])
                        ]),
                        "main-info:relationTypes": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(_unref(MultipleSelect), {
                                    modelValue: selectedRelationTypes.value,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((selectedRelationTypes).value = $event)),
                                    options: relationTypeOptions.value,
                                    label: _ctx.$t('organisation.detail.mainInformation.relationType'),
                                    required: rules.required,
                                    disabled: rules.readonly,
                                    error: getFieldError('relationTypes'),
                                    placeholder: _ctx.$t('organisation.detail.mainInformation.relationTypePlaceholder'),
                                    "search-clear-label": _ctx.$t('common.clearSearch'),
                                    "search-placeholder": _ctx.$t('organisation.detail.mainInformation.relationTypeSearch'),
                                    "select-all-label": _ctx.$t('organisation.detail.mainInformation.relationTypeSelectAll'),
                                    "clear-all-label": _ctx.$t('organisation.detail.mainInformation.relationTypeClearAll'),
                                    "remove-chip-label": _unref(removeChipLabel),
                                    "confirm-label": _ctx.$t('organisation.detail.mainInformation.relationTypeConfirm'),
                                    "empty-label": _ctx.$t('organisation.detail.mainInformation.relationTypeEmpty'),
                                    "full-width": ""
                                }, null, 8 /* PROPS */, ["modelValue", "options", "label", "required", "disabled", "error", "placeholder", "search-clear-label", "search-placeholder", "select-all-label", "clear-all-label", "remove-chip-label", "confirm-label", "empty-label"])
                            ])
                        ]),
                        "main-info:industrySector": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(_unref(SelectInput), {
                                    modelValue: _unref(org).mainInformation.industrySector,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(org).mainInformation.industrySector) = $event)),
                                    label: _ctx.$t('organisation.detail.mainInformation.industrySector'),
                                    options: industrySectorOptions.value,
                                    required: rules.required,
                                    disabled: rules.readonly,
                                    error: getFieldError('industrySector'),
                                    "full-width": ""
                                }, null, 8 /* PROPS */, ["modelValue", "label", "options", "required", "disabled", "error"])
                            ])
                        ]),
                        "main-info:tradeName": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_7, [
                                _createVNode(_unref(TextInput), {
                                    "model-value": _unref(org).mainInformation.tradeName ?? '',
                                    label: _ctx.$t('organisation.detail.mainInformation.tradeName'),
                                    required: rules.required,
                                    disabled: rules.readonly,
                                    maxlength: 255,
                                    error: getFieldError('tradeName'),
                                    "full-width": "",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (_unref(org).mainInformation.tradeName = $event || null))
                                }, null, 8 /* PROPS */, ["model-value", "label", "required", "disabled", "error"])
                            ])
                        ]),
                        "main-info:description": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_8, [
                                _createVNode(_unref(Textarea), {
                                    modelValue: _unref(org).mainInformation.description,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(org).mainInformation.description) = $event)),
                                    label: _ctx.$t('organisation.detail.mainInformation.description'),
                                    disabled: rules.readonly,
                                    "max-length": 1000,
                                    error: getFieldError('description'),
                                    "full-width": ""
                                }, null, 8 /* PROPS */, ["modelValue", "label", "disabled", "error"])
                            ])
                        ]),
                        "admin-info:legalForm": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_9, [
                                _createVNode(_unref(SelectInput), {
                                    modelValue: _unref(org).administrativeInformation.legalForm,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(org).administrativeInformation.legalForm) = $event)),
                                    label: _ctx.$t('organisation.detail.administrativeInformation.legalForm'),
                                    options: legalFormOptions.value,
                                    required: rules.required,
                                    disabled: rules.readonly,
                                    error: getFieldError('legalForm'),
                                    "full-width": ""
                                }, null, 8 /* PROPS */, ["modelValue", "label", "options", "required", "disabled", "error"])
                            ])
                        ]),
                        "admin-info:establishmentNature": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_10, [
                                _createVNode(_unref(SelectInput), {
                                    modelValue: _unref(org).administrativeInformation.establishmentNature,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(org).administrativeInformation.establishmentNature) = $event)),
                                    label: _ctx.$t('organisation.detail.administrativeInformation.establishmentNature'),
                                    options: establishmentNatureOptions.value,
                                    required: rules.required,
                                    disabled: rules.readonly,
                                    error: getFieldError('establishmentNature'),
                                    "full-width": ""
                                }, null, 8 /* PROPS */, ["modelValue", "label", "options", "required", "disabled", "error"])
                            ])
                        ]),
                        "admin-info:registrationDate": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_11, [
                                _createVNode(_unref(DatePickerInput), {
                                    "model-value": _unref(org).administrativeInformation.registrationDate ?? '',
                                    format: "dd/mm/yyyy",
                                    label: _ctx.$t('organisation.detail.administrativeInformation.registrationDate'),
                                    required: rules.required,
                                    disabled: rules.readonly,
                                    error: getFieldError('registrationDate'),
                                    "full-width": "",
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => (_unref(org).administrativeInformation.registrationDate = $event || null))
                                }, null, 8 /* PROPS */, ["model-value", "label", "required", "disabled", "error"])
                            ])
                        ]),
                        "admin-info:headcount": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_12, [
                                _createVNode(_unref(TextInput), {
                                    "model-value": _unref(org).administrativeInformation.headcount?.toString() ?? '',
                                    label: _ctx.$t('organisation.detail.administrativeInformation.headcount'),
                                    type: "number",
                                    min: 0,
                                    required: rules.required,
                                    disabled: rules.readonly,
                                    error: getFieldError('headcount'),
                                    "full-width": "",
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => (_unref(org).administrativeInformation.headcount = $event ? Number($event) : null))
                                }, null, 8 /* PROPS */, ["model-value", "label", "required", "disabled", "error"])
                            ])
                        ]),
                        "admin-info:siret": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_13, [
                                _createVNode(_unref(TextInput), {
                                    modelValue: _unref(org).administrativeInformation.siret,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(org).administrativeInformation.siret) = $event)),
                                    label: _ctx.$t('organisation.detail.administrativeInformation.siret'),
                                    required: rules.required,
                                    disabled: rules.readonly,
                                    maxlength: 50,
                                    error: getFieldError('siret'),
                                    "full-width": ""
                                }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                                    (_unref(org).administrativeInformation.siretValidation)
                                        ? {
                                            name: "iconRight",
                                            fn: _withCtx(() => [
                                                _createVNode(_unref(Popover), {
                                                    position: "top",
                                                    header: _ctx.$t(`organisation.detail.administrativeInformation.siret${validationTitleSuffix(_unref(org).administrativeInformation.siretValidation)}Title`)
                                                }, {
                                                    trigger: _withCtx(({ triggerProps }) => [
                                                        _createElementVNode("button", _mergeProps(triggerProps, {
                                                            type: "button",
                                                            class: validationIconClass(_unref(org).administrativeInformation.siretValidation),
                                                            "aria-label": _ctx.$t(`organisation.detail.administrativeInformation.siret${validationTitleSuffix(_unref(org).administrativeInformation.siretValidation)}Title`)
                                                        }), [
                                                            _createElementVNode("i", {
                                                                class: _normalizeClass([validationIconName(_unref(org).administrativeInformation.siretValidation), "text-base leading-none"]),
                                                                "aria-hidden": "true"
                                                            }, null, 2 /* CLASS */)
                                                        ], 16 /* FULL_PROPS */, _hoisted_14)
                                                    ]),
                                                    default: _withCtx(() => [
                                                        _createTextVNode(" " + _toDisplayString(_ctx.$t(`organisation.detail.administrativeInformation.siret${validationTitleSuffix(_unref(org).administrativeInformation.siretValidation)}Message`)), 1 /* TEXT */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["header"])
                                            ]),
                                            key: "0"
                                        }
                                        : undefined
                                ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "label", "required", "disabled", "error"])
                            ])
                        ]),
                        "admin-info:activityCode": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_15, [
                                _createVNode(_unref(SelectInput), {
                                    modelValue: _unref(org).administrativeInformation.activityCode,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_unref(org).administrativeInformation.activityCode) = $event)),
                                    label: _ctx.$t('organisation.detail.administrativeInformation.activityCode'),
                                    options: activityCodeOptions.value,
                                    required: rules.required,
                                    disabled: rules.readonly,
                                    error: getFieldError('activityCode'),
                                    "full-width": ""
                                }, null, 8 /* PROPS */, ["modelValue", "label", "options", "required", "disabled", "error"])
                            ])
                        ]),
                        "admin-info:vatNumber": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_16, [
                                _createVNode(_unref(TextInput), {
                                    modelValue: _unref(org).administrativeInformation.vatNumber,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_unref(org).administrativeInformation.vatNumber) = $event)),
                                    label: _ctx.$t('organisation.detail.administrativeInformation.vatNumber'),
                                    required: rules.required,
                                    disabled: rules.readonly,
                                    maxlength: 50,
                                    error: getFieldError('vatNumber'),
                                    "full-width": ""
                                }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                                    (_unref(org).administrativeInformation.vatValidation)
                                        ? {
                                            name: "iconRight",
                                            fn: _withCtx(() => [
                                                _createVNode(_unref(Popover), {
                                                    position: "top",
                                                    header: _ctx.$t(`organisation.detail.administrativeInformation.vat${validationTitleSuffix(_unref(org).administrativeInformation.vatValidation)}Title`)
                                                }, {
                                                    trigger: _withCtx(({ triggerProps }) => [
                                                        _createElementVNode("button", _mergeProps(triggerProps, {
                                                            type: "button",
                                                            class: validationIconClass(_unref(org).administrativeInformation.vatValidation),
                                                            "aria-label": _ctx.$t(`organisation.detail.administrativeInformation.vat${validationTitleSuffix(_unref(org).administrativeInformation.vatValidation)}Title`)
                                                        }), [
                                                            _createElementVNode("i", {
                                                                class: _normalizeClass([validationIconName(_unref(org).administrativeInformation.vatValidation), "text-base leading-none"]),
                                                                "aria-hidden": "true"
                                                            }, null, 2 /* CLASS */)
                                                        ], 16 /* FULL_PROPS */, _hoisted_17)
                                                    ]),
                                                    default: _withCtx(() => [
                                                        _createTextVNode(" " + _toDisplayString(_ctx.$t(`organisation.detail.administrativeInformation.vat${validationTitleSuffix(_unref(org).administrativeInformation.vatValidation)}Message`)), 1 /* TEXT */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["header"])
                                            ]),
                                            key: "0"
                                        }
                                        : undefined
                                ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "label", "required", "disabled", "error"])
                            ])
                        ]),
                        "admin-info:turnover": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_18, [
                                _createVNode(_unref(TextInput), {
                                    "model-value": _unref(org).administrativeInformation.turnover?.toString() ?? '',
                                    label: _ctx.$t('organisation.detail.administrativeInformation.turnover'),
                                    type: "number",
                                    min: 0,
                                    required: rules.required,
                                    disabled: rules.readonly,
                                    error: getFieldError('turnover'),
                                    "full-width": "",
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => (_unref(org).administrativeInformation.turnover = $event ? Number($event) : null))
                                }, null, 8 /* PROPS */, ["model-value", "label", "required", "disabled", "error"])
                            ])
                        ]),
                        "admin-info:legalStatus": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_19, [
                                _createVNode(_unref(SelectInput), {
                                    "model-value": _unref(org).administrativeInformation.legalStatus ?? undefined,
                                    label: _ctx.$t('organisation.detail.administrativeInformation.legalStatus'),
                                    options: legalStatusOptions.value,
                                    required: rules.required,
                                    disabled: rules.readonly || _unref(org).administrativeInformation.legalStatus === 'Ceased',
                                    error: getFieldError('legalStatus'),
                                    "full-width": "",
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => (_unref(org).administrativeInformation.legalStatus = $event ?? null))
                                }, null, 8 /* PROPS */, ["model-value", "label", "options", "required", "disabled", "error"])
                            ])
                        ]),
                        "admin-info:parentOrganisationId": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_20, [
                                _createVNode(_unref(AutoComplete), _mergeProps(_unref(buildAutoCompleteLabels)(_unref(t)), {
                                    "model-value": _unref(org).administrativeInformation.parentOrganisationId ?? '',
                                    label: _ctx.$t('organisation.detail.administrativeInformation.parentOrganisationName'),
                                    placeholder: _ctx.$t('organisation.detail.administrativeInformation.parentOrganisationPlaceholder'),
                                    options: parentOrganisationSuggestions.value,
                                    disabled: rules.readonly,
                                    error: getFieldError('parentOrganisationId'),
                                    "full-width": "",
                                    "create-label": rules.readonly ? undefined : _ctx.$t('common.createNewOrganisation'),
                                    "onUpdate:modelValue": onParentOrganisationModelUpdate,
                                    onSearch: onParentOrganisationSearch,
                                    onSelect: onParentOrganisationSelect,
                                    onCreate: _cache[16] || (_cache[16] = ($event) => (openCreateParentOrg()))
                                }), null, 16 /* FULL_PROPS */, ["model-value", "label", "placeholder", "options", "disabled", "error", "create-label"])
                            ])
                        ]),
                        "communication:actions": _withCtx(() => [
                            _createVNode(_unref(Tooltip), {
                                text: channelTooltip.value,
                                disabled: canInteractWithChannels.value,
                                tabindex: !canInteractWithChannels.value ? 0 : undefined
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(Dropdown), {
                                        items: coordonneesAddItems.value,
                                        "menu-align": "right"
                                    }, {
                                        trigger: _withCtx(({ triggerProps }) => [
                                            _createVNode(_unref(Button), _mergeProps(triggerProps, {
                                                variant: "primary",
                                                size: "sm",
                                                "icon-left": "ri-add-line",
                                                "dropdown-icon": "",
                                                label: _ctx.$t('common.addNew'),
                                                disabled: !canInteractWithChannels.value
                                            }), null, 16 /* FULL_PROPS */, ["label", "disabled"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["items"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["text", "disabled", "tabindex"])
                        ]),
                        "communication:phones": _withCtx(() => [
                            _createElementVNode("div", _hoisted_21, [
                                _createVNode(OrganisationCoordonneesSection, {
                                    phones: _unref(org).contactInformation.phones,
                                    emails: _unref(org).contactInformation.emails,
                                    "can-interact": canInteractWithChannels.value,
                                    tooltip: channelTooltip.value,
                                    onEditPhone: openEditPhone,
                                    onEditEmail: openEditEmail
                                }, null, 8 /* PROPS */, ["phones", "emails", "can-interact", "tooltip"])
                            ])
                        ]),
                        "communication:domainName": _withCtx(({ rules }) => [
                            _createElementVNode("div", _hoisted_22, [
                                _createVNode(_unref(UrlInput), {
                                    "model-value": _unref(org).contactInformation.domainName ?? '',
                                    label: _ctx.$t('organisation.detail.communication.domainName'),
                                    disabled: rules.readonly,
                                    error: getFieldError('domainName'),
                                    "invalid-url-message": _ctx.$t('errors.domain'),
                                    prefix: "https://",
                                    "button-labels": {
                                        label: _ctx.$t('organisation.detail.communication.copy'),
                                        labelWhenCopied: _ctx.$t('organisation.detail.communication.copied'),
                                    },
                                    "full-width": "",
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => (_unref(org).contactInformation.domainName = $event || null)),
                                    onValidationChange: onDomainNameValidationChange
                                }, null, 8 /* PROPS */, ["model-value", "label", "disabled", "error", "invalid-url-message", "button-labels"])
                            ])
                        ]),
                        "communication:socialLinks": _withCtx(() => [
                            _createElementVNode("div", _hoisted_23, [
                                _createVNode(OrganisationSocialProfileSection, {
                                    profiles: socialProfiles.value,
                                    "can-interact": canInteractWithChannels.value,
                                    tooltip: channelTooltip.value,
                                    onEdit: openEditSocialProfile
                                }, null, 8 /* PROPS */, ["profiles", "can-interact", "tooltip"])
                            ])
                        ]),
                        "extra:addresses": _withCtx(() => [
                            _createVNode(AddressesWidget, {
                                addresses: sortedAddresses.value,
                                "can-edit": _unref(canEdit),
                                "onUpdate:primaryId": _unref(setPrimaryAddress),
                                onAdd: _unref(openAddAddress),
                                onEdit: _unref(openEditAddress),
                                onDelete: _unref(deleteAddress),
                                onExpand: _cache[18] || (_cache[18] = ($event) => (showAddressesModal.value = true))
                            }, null, 8 /* PROPS */, ["addresses", "can-edit", "onUpdate:primaryId", "onAdd", "onEdit", "onDelete"])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["layout", "headers"]))
                    : _createCommentVNode("v-if", true),
                _createVNode(AddressDetailsModal, {
                    modelValue: _unref(showAddressModal),
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => (_isRef(showAddressModal) ? (showAddressModal).value = $event : null)),
                    "initial-details": _unref(addressDetails),
                    readonly: !_unref(canEdit),
                    onSave: onAddressDetailsModalSave
                }, null, 8 /* PROPS */, ["modelValue", "initial-details", "readonly"]),
                _createVNode(OrganisationAddPhoneModal, {
                    modelValue: showAddPhoneModal.value,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((showAddPhoneModal).value = $event)),
                    "organisation-id": __props.organisationId,
                    "has-primary-phone": hasPrimaryPhone.value,
                    onCreated: _cache[21] || (_cache[21] = ($event) => (emit('channelSaved')))
                }, null, 8 /* PROPS */, ["modelValue", "organisation-id", "has-primary-phone"]),
                (editingPhone.value)
                    ? (_openBlock(), _createBlock(OrganisationEditPhoneModal, {
                        key: 1,
                        modelValue: showEditPhoneModal.value,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((showEditPhoneModal).value = $event)),
                        "organisation-id": __props.organisationId,
                        "channel-id": editingPhone.value.id,
                        "initial-value": editingPhone.value.number,
                        "initial-is-primary": editingPhone.value.isPrimary,
                        "initial-sub-type": editingPhone.value.subType,
                        onUpdated: _cache[23] || (_cache[23] = ($event) => (emit('channelSaved'))),
                        onDelete: onPhoneDeleteRequested
                    }, null, 8 /* PROPS */, ["modelValue", "organisation-id", "channel-id", "initial-value", "initial-is-primary", "initial-sub-type"]))
                    : _createCommentVNode("v-if", true),
                _createVNode(_unref(ConfirmDeleteModal), {
                    modelValue: showDeletePhoneConfirm.value,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((showDeletePhoneConfirm).value = $event)),
                    title: _ctx.$t('organisation.detail.communication.deletePhoneMessage'),
                    subtitle: pendingPhoneDelete.value?.isPrimary
                        ? _ctx.$t('organisation.detail.communication.deletePhonePrimaryWarning')
                        : _ctx.$t('organisation.detail.communication.deleteConfirmSubtitle'),
                    "confirm-label": _ctx.$t('organisation.detail.communication.deletePhoneConfirmLabel'),
                    "cancel-label": _ctx.$t('form.cancel'),
                    "confirm-disabled": pendingPhoneDelete.value?.isPrimary === true,
                    onConfirm: confirmPhoneDelete,
                    onCancel: cancelPhoneDelete
                }, null, 8 /* PROPS */, ["modelValue", "title", "subtitle", "confirm-label", "cancel-label", "confirm-disabled"]),
                _createVNode(OrganisationAddEmailModal, {
                    modelValue: showAddEmailModal.value,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((showAddEmailModal).value = $event)),
                    "organisation-id": __props.organisationId,
                    "has-primary-email": hasPrimaryEmail.value,
                    onCreated: _cache[26] || (_cache[26] = ($event) => (emit('channelSaved')))
                }, null, 8 /* PROPS */, ["modelValue", "organisation-id", "has-primary-email"]),
                (editingEmail.value)
                    ? (_openBlock(), _createBlock(OrganisationEditEmailModal, {
                        key: 2,
                        modelValue: showEditEmailModal.value,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((showEditEmailModal).value = $event)),
                        "organisation-id": __props.organisationId,
                        "channel-id": editingEmail.value.id,
                        "initial-value": editingEmail.value.address,
                        "initial-is-primary": editingEmail.value.isPrimary,
                        onUpdated: _cache[28] || (_cache[28] = ($event) => (emit('channelSaved'))),
                        onDelete: onEmailDeleteRequested
                    }, null, 8 /* PROPS */, ["modelValue", "organisation-id", "channel-id", "initial-value", "initial-is-primary"]))
                    : _createCommentVNode("v-if", true),
                _createVNode(_unref(ConfirmDeleteModal), {
                    modelValue: showDeleteEmailConfirm.value,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => ((showDeleteEmailConfirm).value = $event)),
                    title: _ctx.$t('organisation.detail.communication.deleteEmailMessage'),
                    subtitle: pendingEmailDelete.value?.isPrimary
                        ? _ctx.$t('organisation.detail.communication.deleteEmailPrimaryWarning')
                        : _ctx.$t('organisation.detail.communication.deleteConfirmSubtitle'),
                    "confirm-label": _ctx.$t('organisation.detail.communication.deleteEmailConfirmLabel'),
                    "cancel-label": _ctx.$t('form.cancel'),
                    "confirm-disabled": pendingEmailDelete.value?.isPrimary === true,
                    onConfirm: confirmEmailDelete,
                    onCancel: cancelEmailDelete
                }, null, 8 /* PROPS */, ["modelValue", "title", "subtitle", "confirm-label", "cancel-label", "confirm-disabled"]),
                _createVNode(_unref(ConfirmDeleteModal), {
                    modelValue: _unref(showDeleteAddressModal),
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => (_isRef(showDeleteAddressModal) ? (showDeleteAddressModal).value = $event : null)),
                    title: _ctx.$t('organisation.detail.addresses.deleteModal.confirmTitle'),
                    subtitle: _unref(pendingDeleteAddress)?.isPrimary
                        ? _ctx.$t('organisation.detail.addresses.deleteModal.primaryWarning')
                        : _ctx.$t('organisation.detail.addresses.deleteModal.subtitle'),
                    "confirm-label": _ctx.$t('organisation.detail.addresses.deleteModal.confirmLabel'),
                    "cancel-label": _ctx.$t('form.cancel'),
                    "confirm-disabled": _unref(pendingDeleteAddress)?.isPrimary === true,
                    onConfirm: _unref(confirmDeleteAddress),
                    onCancel: _unref(cancelDeleteAddress)
                }, null, 8 /* PROPS */, ["modelValue", "title", "subtitle", "confirm-label", "cancel-label", "confirm-disabled", "onConfirm", "onCancel"]),
                _createVNode(AddressesExpandModal, {
                    modelValue: _unref(showAddressesModal),
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => (_isRef(showAddressesModal) ? (showAddressesModal).value = $event : null)),
                    addresses: sortedAddresses.value,
                    "primary-id": _unref(primaryAddressId),
                    "can-edit": _unref(canEdit),
                    "onUpdate:primaryId": _unref(setPrimaryAddress),
                    onEdit: _unref(openEditAddress),
                    onDelete: _unref(deleteAddress)
                }, null, 8 /* PROPS */, ["modelValue", "addresses", "primary-id", "can-edit", "onUpdate:primaryId", "onEdit", "onDelete"]),
                _createVNode(AddressFormModal, {
                    modelValue: _unref(showAddressFormModal),
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event) => (_isRef(showAddressFormModal) ? (showAddressFormModal).value = $event : null)),
                    address: _unref(editingAddress),
                    "can-edit": _unref(canEdit),
                    onSave: _unref(saveAddress)
                }, null, 8 /* PROPS */, ["modelValue", "address", "can-edit", "onSave"]),
                _createVNode(_unref(SocialProfileFormModal), {
                    modelValue: showSocialProfileModal.value,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event) => ((showSocialProfileModal).value = $event)),
                    profile: editingSocialProfile.value,
                    "existing-network-ids": editingSocialProfile.value ? [] : socialProfiles.value.map(p => p.networkId),
                    error: socialModalError.value,
                    loading: socialModalLoading.value,
                    "platform-picker-enabled": "",
                    "delete-enabled": !!editingSocialProfile.value,
                    onSave: onSocialProfileSave,
                    onDelete: _cache[34] || (_cache[34] = ($event) => (onSocialProfileDelete(editingSocialProfile.value)))
                }, null, 8 /* PROPS */, ["modelValue", "profile", "existing-network-ids", "error", "loading", "delete-enabled"]),
                (createParentOrgMounted.value)
                    ? (_openBlock(), _createBlock(CreateOrganisationModal, {
                        key: 3,
                        modelValue: showCreateParentOrg.value,
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event) => ((showCreateParentOrg).value = $event)),
                        "redirect-on-create": false,
                        "initial-name": parentOrgQuery.value,
                        onCreated: onParentOrgCreated
                    }, null, 8 /* PROPS */, ["modelValue", "initial-name"]))
                    : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
